import type { Question } from "@circle-react/types/Live/QA/Question";
import {
  reactQueryDelete,
  reactQueryPatch,
  reactQueryPost,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

interface CreateQAQuestionParams {
  formData: Record<string, unknown>;
  roomId?: string | number;
}

const createQAQuestion = ({ roomId, formData }: CreateQAQuestionParams) =>
  reactQueryPost(
    internalApi.liveStreams.createQAQuestion({ roomId }),
    formData,
  );

interface RemoveQAQuestionParams {
  id?: string | number;
  roomId?: string | number;
}

const removeQAQuestion = ({ roomId, id }: RemoveQAQuestionParams) =>
  reactQueryDelete<Question>(
    internalApi.liveStreams.removeQAQuestion({ roomId, id }),
  );

interface ApproveQAQuestionParams {
  id?: string | number;
  roomId?: string | number;
}

const approveQAQuestion = ({ roomId, id }: ApproveQAQuestionParams) =>
  reactQueryPatch<Question>(
    internalApi.liveStreams.approveQAQuestion({ roomId, id }),
  );

interface DismissQAQuestionParams {
  id?: string | number;
  roomId?: string | number;
}

const dismissQAQuestion = ({ roomId, id }: DismissQAQuestionParams) =>
  reactQueryPatch<Question>(
    internalApi.liveStreams.dismissQAQuestion({ roomId, id }),
  );

interface MarkQAQuestionAsAnsweredParams {
  id?: string | number;
  roomId?: string | number;
}

const markQAQuestionAsAnswered = ({
  roomId,
  id,
}: MarkQAQuestionAsAnsweredParams) =>
  reactQueryPatch<Question>(
    internalApi.liveStreams.markQAQuestionAsAnswered({ roomId, id }),
  );

interface BringBackQAQuestionParams {
  id?: string | number;
  roomId?: string | number;
}

const bringBackQAQuestion = ({ roomId, id }: BringBackQAQuestionParams) =>
  reactQueryPatch<Question>(
    internalApi.liveStreams.bringBackQAQuestion({ roomId, id }),
  );

interface UpvoteQAQuestionParams {
  id?: string | number;
  roomId?: string | number;
}

const upvoteQAQuestion = ({ roomId, id }: UpvoteQAQuestionParams) =>
  reactQueryPatch<Question>(
    internalApi.liveStreams.upvoteQAQuestion({ roomId, id }),
  );

interface RemoveUpvoteQAQuestionParams {
  id?: string | number;
  roomId?: string | number;
}

const removeUpvoteQAQuestion = ({ roomId, id }: RemoveUpvoteQAQuestionParams) =>
  reactQueryPatch<Question>(
    internalApi.liveStreams.removeUpvoteQAQuestion({ roomId, id }),
  );

interface SpotlightQAQuestionParams {
  id?: string | number;
  roomId?: string | number;
}

const spotlightQAQuestion = ({ roomId, id }: SpotlightQAQuestionParams) =>
  reactQueryPatch<Question>(
    internalApi.liveStreams.spotlightQAQuestion({ roomId, id }),
  );

interface RemoveSpotlightQAQuestionParams {
  id?: string | number;
  roomId?: string | number;
}

const removeSpotlightQAQuestion = ({
  roomId,
  id,
}: RemoveSpotlightQAQuestionParams) =>
  reactQueryPatch<Question>(
    internalApi.liveStreams.removeSpotlightQAQuestion({ roomId, id }),
  );

export const QAQuestionsApi = {
  createQAQuestion,
  removeQAQuestion,
  approveQAQuestion,
  dismissQAQuestion,
  markQAQuestionAsAnswered,
  bringBackQAQuestion,
  upvoteQAQuestion,
  removeUpvoteQAQuestion,
  spotlightQAQuestion,
  removeSpotlightQAQuestion,
};
